import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import style from './Verification.scss';

const cn = bemCssModules(style, 'Verification');

export type TEmailTooltip = {
  onClick?(): void;
  onClickSupport?(): void;
  id?: string;
};

const EmailTooltip: CustomFC<TEmailTooltip> = ({ onClick, onClickSupport, id }) => {
  const { t } = useTranslation();
  return (
    <>
      <b>{t('verify.email.tooltip.title')}</b>
      <div className={cn('list-wrapper')}>
        <ol className={cn('tooltip-list')}>
          <li className={cn('item')}>
            <Trans i18nKey="verify.email.tooltip.li1">
              text
              <label htmlFor={id} className={cn('link', ['link'])} onClick={onClick} />
            </Trans>
          </li>
          <li className={cn('item')}>{t('verify.email.tooltip.li2')}</li>
          <li className={cn('item')}>
            <Trans i18nKey="verify.email.tooltip.li3">
              text
              <a
                className={cn('link', ['link'])}
                href="mailto:support@mercuryo.io"
                onClick={onClickSupport}
              >
                text
              </a>
            </Trans>
          </li>
        </ol>
      </div>
    </>
  );
};

export default EmailTooltip;
